<template>
  <div class="press">
    <div v-for="(link, index) in pressLinks" :key="index">
      <press-link
        v-bind="link"
        v-model="updatedPressLinks[index]"
        @remove="removeLink(index)"
      />
    </div>
    <div class="press__add">
      <a @click="addLink">Add press link</a>
    </div>
    <button @click="save" :disabled="isSaving">Save</button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import PressLink from './PressLink.vue';

export default {
  name: 'ManagePress',
  components: {
    PressLink,
  },
  computed: {
    ...mapGetters(['getSite']),
  },
  data() {
    return {
      pressLinks: [],
      updatedPressLinks: [],
      isSaving: false,
    };
  },
  created() {
    this.pressLinks = this.getSite.pressLinks;
  },
  methods: {
    ...mapActions(['update']),
    addLink() {
      this.pressLinks.push({
        title: '',
        publication: '',
        url: '',
      });
    },
    removeLink(index) {
      this.pressLinks.splice(1, index);
      this.updatedPressLinks.splice(1, index);
    },
    save() {
      this.isSaving = true;
      this.update({
        model: 'site',
        id: 'press',
        value: {
          links: this.updatedPressLinks,
        },
      }).then(() => {
        this.isSaving = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.press {
  text-align: center;
  button {
    margin-top: 20px;
  }
  &__add {
    margin-bottom: 20px;
  }
}
</style>
